module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h1', {
    staticClass: "downloaarticle-main-title"
  }, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        You have downloaded All Football App, which is the updated version of this website and will provide you with\n        better using experience.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("1. Download the app")]), _vm._v(" "), (!_vm.is_opreamini) ? _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        If you accidentally cancel the download, you can click on the link below to re-download it.\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "download-btn",
    attrs: {
      "src": require("../assets/download/download_btn.png")
    },
    on: {
      "click": _vm.jumpUrl
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/download/download_pic1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("2. Adjust the phone's setup")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/download/download_pic2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("3. Install the app")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/download/download_pic3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_c('b', {
    staticClass: "download-article-bold"
  }, [_vm._v("Below are some introductions to how to install our App.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        If the usual warning about possible device damage appears, confirm "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"OK\"")]), _vm._v(" - we guarantee\n        that our app will definitely not harm your device.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        You'll find the downloaded app in "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifications\"")]), _vm._v(" or in the "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Download\"")]), _vm._v(" folder. Click on it, choose "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Install\"")]), _vm._v(" and confirm.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        You'll find the downloaded app in "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifications\"")]), _vm._v(" or in the "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Download\"")]), _vm._v(" folder. Click on it, choose "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Install\"")]), _vm._v(" and confirm.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-bottom"
  }, [_c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("Did not work?")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n            Try it once again following the instructions above. Or download the latest app version from "), _c('a', {
    attrs: {
      "href": "https://at.umeng.com/SbK5Lf"
    }
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("Google_Play")])]), _vm._v(".\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56857d9e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppDownload.vue
// module id = 749
// module chunks = 11